export default "__VITE_ASSET__CcQb_XaI__"